import React from "react";
import styled from "styled-components";
import { ListItemText } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { StyledText } from "src/scenes/Chat/components/styled/shared";
import ListDate from "../ListDate";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const useStyles = makeStyles(() => ({
    outlined: {
        "&:focus": {
            outline: "none",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
    },
    listItemSecondary: {
        color: "#000"
    }
}));

const ChatListText = styled(StyledText)`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const PrimaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
`;

const Content = styled.span`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-style: ${p => p.italic || ""}
`;

const ListText = ({ chatName, latestEvent, showTimestamp, matrixRoomLoading, chat }) => {
    const classes = useStyles();
    let displayMessage = "";
    if (!matrixRoomLoading) {
        displayMessage = chat?.matrixRoom ? chat.getDisplayMessage(chat.matrixRoom) : "";
    }
    const fontStyle = displayMessage === "No messages yet" ? "italic" : "";
    return (
        <ListItemText
            primary={
                <PrimaryRow>
                    <ChatListText size="1rem" weight="700">{chatName}</ChatListText>
                    {showTimestamp && latestEvent && <ListDate timestamp={latestEvent.getTs()} align="right" />}
                </PrimaryRow>
            }
            secondary={ !matrixRoomLoading ? <Content italic={fontStyle}>{displayMessage}</Content> : <Skeleton height={18} width="60%" /> }
            classes={{ secondary: classes.listItemSecondary }}
        />
    );
};

export default ListText;
